import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  fill: "none",
  viewBox: "0 0 19 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.68",
      d: "M10.007 5.007 6.424 1.424a2.01 2.01 0 0 0-2.833 0L1.424 3.59a2.01 2.01 0 0 0 0 2.833l3.583 3.583m.834-5.833 1.666-1.667m6.667 10 1.667-1.666m-2.5-2.5 3.583 3.583c.783.783.783 2.05 0 2.833l-2.167 2.167a2 2 0 0 1-2.833 0L8.34 13.34m3.333-10 3.333 3.333m1.812-1.823a2.35 2.35 0 1 0-3.322-3.323L2.376 12.652c-.194.193-.337.43-.417.692l-1.1 3.627a.417.417 0 0 0 .518.518l3.628-1.1c.26-.08.498-.222.69-.414z"
    }, null, -1)
  ]))]))
}
export default { render: render }